import React from 'react';
import { Overlay, Text } from 'react-native-elements';
import { ActivityIndicator, View } from 'react-native';

interface ScreenActivityProp {
	active: boolean;
	msg?: string;
}

export default function ScreenActivity({ active, msg }: ScreenActivityProp): JSX.Element {
	return (
		<Overlay isVisible={active} overlayStyle={{ width: 200, height: 200, justifyContent: 'center' }}>
			<View>
				<ActivityIndicator animating={true} />
				{msg ? <Text style={{ textAlign: 'center', marginTop: 20 }}>{msg}</Text> : <></>}
			</View>
		</Overlay>
	);
}
